import {
  EnelXGuiAtoms, EnelXGuiConsts, EnelXGuiUtils,
} from 'gui';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  useLocation,
} from 'react-router-dom';

import Ticket from 'components/Ticket';

import sw from '../../../package.json';

const { MigrationFooter, DsyLink } = EnelXGuiAtoms;

const {
  COLOR_NEUTRAL_LIGHTER,
} = EnelXGuiConsts;

const {
  getDsyTokenValue,
} = EnelXGuiUtils;

const Footer = ({ isPrimaryActionAvailable }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const canOpenTicket = isPrimaryActionAvailable ? isPrimaryActionAvailable('openTicket') : false;

  const ticketSlot = {
    id: 'ticket',
    element: () => (
      <Ticket />
    ),
  };

  const FOOTER_SLOTS = [
    {
      id: 'fist',
      element: () => (
        <div className="flex flex-col items-center justify-center gap-4 py-4">
          <div className="mr-1">
            {t('enelSpa')}
          </div>
          <div className="mr-1">
            <Trans
              i18nKey="allRightsReserved"
              values={{ phoneNumber: '800900860' }}
              components={{
                phone: (
                  <a
                    className="text-primary-reddishPink hover:text-primary-strongPink"
                    href={`tel:${800900860}`}
                  >
                    800900860
                  </a>
                ),
              }}
            />
          </div>
          <div className="flex justify-center text-primary-violetPurple">
            {`${t('version')} ${sw.version}`}
          </div>
        </div>
      ),
    },
  ];

  if (canOpenTicket) {
    FOOTER_SLOTS.push(ticketSlot);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [location]);

  const footerColor = getDsyTokenValue(COLOR_NEUTRAL_LIGHTER);

  return (
    <MigrationFooter
      slotNames={FOOTER_SLOTS.map((slot) => slot?.id)}
      customStyle={`background-color: ${footerColor}; justify-content: space-between`}
    >
      {
        FOOTER_SLOTS.map(({ id, element }) => (<div slot={id} key={id}>{element()}</div>))
      }
    </MigrationFooter>
  );
};

export default Footer;
